/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description:  Module for Debris References Index component for the Impact Evaluation Dashboard  
Author: Deimos Space UK

Version: 1.0
*/ 
import React, { useState, useEffect } from "react";
import { Card, CardBody, Row, Button, Alert, Dropdown, DropdownToggle, DropdownMenu, Col } from "reactstrap";
import Chart from "react-apexcharts";
import { ESA_COLORS } from "../../../../core/models/colors";
import { getPetition } from "../../../../api/api";
import Spinner from 'react-bootstrap/Spinner';
import { useParams } from "react-router-dom";
import Select, { components } from 'react-select';
import useDebounce from '../../../../hooks/useDebounce'
import Switch from "react-switch";

import { toast } from 'react-toastify';

export default function DebrisReferencesIndex({ missionName, constellation, missionId, spacecraftId, spacecraftIdArray }) {
  const [dataLineChart, setDataLineChart] = useState([]);
  const [years, setYears] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [dropdownOpenMission, setdropdownOpenMission] = useState(false);
  const toggle2 = () => setdropdownOpenMission((prevState) => !prevState);
  const [missionOptions, setMissionOptions] = useState([]);
  const [optionsSelected, setOptionsSelected] = useState([]);
  const [pointPMDLocation, setPointPMD] = useState([])
  const [logartihmic, setLogartihmic] = useState(false)
  const [missionNamesArray, setMissionNamesArray] = useState([])
  const [idArray, setIdArray] = useState([]);
  const [spacecraftIdArrayState, setSpacecraftIdArrayState] = useState([])
  const [spacecraftsComparation, setSpacecraftComparation] = useState([])
  const [draft, setDraft] = useState(false)


  useEffect(() => {
    setSpacecraftIdArrayState(spacecraftIdArray)

  }, [spacecraftIdArray])

  useEffect(() => {
    setMissionOptions([])
  }, [draft])

  useEffect(() => {
    if (optionsSelected.length === 0) {
      setIdArray([])
      setMissionNamesArray([])
      setSpacecraftComparation([])
      setPointPMD([])
      setdropdownOpenMission(false)

    }
  }, [optionsSelected])

  const getMaxValue = () => {
    let max = 0
    dataLineChart.map((item) => {
      if (item && item.data) {
        item.data.map((value) => {
          if (value > max) {
            max = value
          }
        })
      }
    })
    return max
  }

  const getMinValue = () => {
    let min = 0
    dataLineChart.map((item) => {
      if (item && item.data) {
        item.data.map((value) => {
          if (value < min) {
            min = value
          }
        })
      }
    })
    return min
  }

  const apexLineChartWithLables = {
    chart: {
      height: 280,
      type: "line",
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return logartihmic ? val : val.toExponential(3);
        },

      },
    },
    colors: ESA_COLORS,
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 1,
    },

    grid: {
      show: true,      // you can either change hear to disable all grids
      xaxis: {
        lines: {
          show: true  //or just here to disable only x axis grids
        }
      },
      yaxis: {
        lines: {
          show: true  //or just here to disable only y axis
        },
      
      },
    },

    yaxis: {
      labels: {
        formatter: function (val) {
          if (val) {
            if(logartihmic){
              return Math.pow(10, val).toExponential(3);
            }else{
              return val.toExponential(3);
            }
          }
        },
      },
      lines: {
        show: true,
      },
      forceNiceScale: false,
      tickAmount: 5,
      min: getMinValue(),
      max: getMaxValue()
    },
    xaxis: {
      title: {
        text: 'Years',
        offsetX: 0,
        offsetY: 130,
        style: {
          fontSize: '14px',
        },
      },
      categories: years,
      lines: {
        show: true,
      },
      tickAmount: 20,


    },
    animations: {
      enabled: false
    },
    legend: {
      show: true,
      position: "top",
      horizontalAlign: "right",
      floating: true,
      offsetY: -3,


    },
    annotations: {
      points: pointPMDLocation.map((point, index) => ({

        x: point.x,
        y: point.y,
        marker: {
          size: point.marker.size,
          fillColor: point.marker.fillColor,
          strokeColor: point.marker.strokeColor,
          radius: point.marker.radius,
        },
      })),
    },
    options: {
      xaxis: {
        categories: years,
      },
    }

  };
  const { id } = useParams();

  useEffect(() => {
    setOptionsSelected([])
    setIdArray([])
    setMissionNamesArray([])
    setSpacecraftComparation([])
    setPointPMD([])
    setdropdownOpenMission(false)
  }, [spacecraftId])


  useEffect(() => {
    if (id && idArray.length === 0 && !constellation && spacecraftId === null && spacecraftIdArrayState && spacecraftIdArrayState[0]) {

      getPetition(`/api/debris_index/debris_index_profile_for_spacecraft?spacecraft_id=${spacecraftIdArrayState[0]}`)
        .then((data) => {
          setLineChart([{ mission: id, value: data.debris_index_profile }], logartihmic)
          setLoading(false)
        })
        .catch((error) => {
          setLoading(false)
          setError(true)
        })

    }
    else {
      if (idArray.length > 0) {
        const spacecraftsIds = []
        idArray.forEach((mission) => {
          getPetition(`/api/mission/object_data?mission_id=${mission}`)
            .then((data) => {
              data?.map((item) => {

                if (item.space_vehicle_id) {
                  spacecraftsIds.push(item.space_vehicle_id)

                  if (idArray.length === spacecraftsIds.length) {
                    spacecraftsIds.unshift((constellation && spacecraftId) ? spacecraftId : spacecraftIdArray[0])
                    setSpacecraftComparation(spacecraftsIds)
                  }
                }
              })
            })
            .catch((error) => {
              console.log(error)
            })


        })



      }

      if (constellation && spacecraftId === null) {
        getPetition(`/api/debris_index/debris_index_profile_for_mission?mission_id=${missionId}`)
          .then((data) => {
            setLineChartConstellation([{ mission: missionId, value: data.debris_index_profile }], logartihmic)
            setLoading(false)
          })
          .catch((error) => {
            setLoading(false)
            setError(true)
          })
      } else if (constellation && spacecraftId !== null) {
        getPetition(`/api/debris_index/debris_index_profile_for_spacecraft?spacecraft_id=${spacecraftId}`)
          .then((data) => {
            setLineChart([{ mission: spacecraftId, value: data.debris_index_profile }], logartihmic)
            setLoading(false)
          })
          .catch((error) => {
            setLoading(false)
            setError(true)
          })
      }
    }
  }, [id,
    logartihmic,
    spacecraftIdArrayState,
    spacecraftId,
    constellation,
    missionId,
    idArray]);



  useEffect(() => {
    if (spacecraftsComparation.length > 0) {
      const lineChart = []
      spacecraftsComparation.forEach((mission) => {
        getPetition(`/api/debris_index/debris_index_profile_for_spacecraft?spacecraft_id=${mission}`)
          .then((data) => {
            lineChart.push({ mission: mission, value: data.debris_index_profile })
            if (lineChart.length === spacecraftsComparation.length) {
              setLineChart(lineChart, logartihmic)
              setLoading(false)
            }
          })
          .catch((error) => {
            console.log(error)
            setLoading(false)
          })

      })
    }
  }, [spacecraftsComparation, logartihmic])

  const setLineChartConstellation = (data, log) => {
    if (data && data.length > 0) {
      const apexLineChartWithLablesData = []
      const years = []

      const pointPMD = []
      data.map((spacecraft, index2) => {
        const deployment = []
        const operational = []
        const decommissioning = []

        spacecraft.value.map((item, index) => {
          if (item.deployment) {
            deployment.push(log ? Math.log10(item.deployment) : item.deployment)
            operational.push(null)
            decommissioning.push(null)
          } else if (item.operational) {
            if (spacecraft.value[index - 1] && spacecraft.value[index - 1].deployment) {
              deployment.push(log ? Math.log10(item.operational) : item.operational)
            }
            operational.push(log ? Math.log10(item.operational) : item.operational)
            decommissioning.push(null)
          } else if (item.decommissioning) {
            if (spacecraft.value[index - 1] && spacecraft.value[index - 1].operational) {
              operational.push(log ? Math.log10(item.decommissioning) : item.decommissioning)
            }
            decommissioning.push(log ? Math.log10(item.decommissioning) : item.decommissioning)
          }
          years.push(item.year)
        })
        apexLineChartWithLablesData.push({
          name: idArray.length > 0 ? `${missionNamesArray[index2]} Deployment` : `Deployment`,
          data: deployment,
        })
        apexLineChartWithLablesData.push(
          {
            name: idArray.length > 0 ? `${missionNamesArray[index2]} Operational` : `Operational`,
            data: operational,
          })
        apexLineChartWithLablesData.push(
          {
            name: idArray.length > 0 ? `${missionNamesArray[index2]} Decommissioning` : `Decommissioning`,
            data: decommissioning,
          })

      })
      const lineChartData = apexLineChartWithLablesData.filter((item) => item.data.some((e) => e !== null && e !== 0) === true)
      const pointArray = pointPMDLocation
      for (let i = 0; i < pointPMD.length / 2; i++) {
        pointArray.push({
          x: pointPMD[i],
          y: logartihmic && !isNaN(Math.log10(pointPMD[i + 1])) ? Math.log10(pointPMD[i + 1]) : pointPMD[i + 1],
          marker: {
            size: 4,
            fillColor: ESA_COLORS[2],
            strokeColor: ESA_COLORS[2],
            radius: 2,
          },
        })
      }
      setPointPMD(pointArray)
      setDataLineChart(lineChartData)
      setYears(years)
    }

  }



  const setLineChart = (data, log) => {
    if (data && data.length > 0) {
      const apexLineChartWithLablesData = []
      const years = []
      const pointPMD = []
      data.map((spacecraft, index2) => {
        const launch = []
        const injection = []
        const operational = []
        const no_disposal = []
        const direct_disposal = []
        const reorbit_disposal = []
        const targeted_disposal = []
        spacecraft.value.map((item, index) => {
          if (item.launch) {
            launch.push(log ? Math.log10(item.launch) : item.launch)
            injection.push(null)
            operational.push(null)
            no_disposal.push(null)
            direct_disposal.push(null)
            reorbit_disposal.push(null)
            targeted_disposal.push(null)
          } else if (item.injection) {
            if (spacecraft.value[index - 1] && spacecraft.value[index - 1].launch) {
              launch.push(log ? Math.log10(item.injection) : item.injection)
            }
            injection.push(log ? Math.log10(item.injection) : item.injection)
            operational.push(null)
            no_disposal.push(null)
            direct_disposal.push(null)
            reorbit_disposal.push(null)
            targeted_disposal.push(null)
          } else if (item.operational) {
            if (spacecraft.value[index - 1] && spacecraft.value[index - 1].injection) {
              injection.push(log ? Math.log10(item.operational) : item.operational)
            }
            operational.push(log ? Math.log10(item.operational) : item.operational)
            no_disposal.push(null)
            direct_disposal.push(null)
            reorbit_disposal.push(null)
            targeted_disposal.push(null)
            if (pointPMD.length === 0 && spacecraft.value[index + 1] && spacecraft.value[index + 1].pmd) {
              pointPMD.push(item.year)
              pointPMD.push(log ? Math.log10(item.operational) : item.operational)
            }


          } else if (item.pmd) {
            if (item.pmd.no_disposal) {
              if (no_disposal.some((e) => e !== null && e !== 0) === false) {
                no_disposal[no_disposal.length - 1] = operational[operational.length - 1]
              }
              no_disposal.push(log ? Math.log10(item.pmd.no_disposal) : item.pmd.no_disposal)

            }
            if (item.pmd.direct_disposal) {
              if (direct_disposal.some((e) => e !== null && e !== 0) === false) {
                direct_disposal[direct_disposal.length - 1] = operational[operational.length - 1]
              }
              direct_disposal.push(log ? Math.log10(item.pmd.direct_disposal) : item.pmd.direct_disposal)

            }
            if (item.pmd.reorbit_disposal) {
              if (reorbit_disposal.some((e) => e !== null && e !== 0) === false) {
                reorbit_disposal[reorbit_disposal.length - 1] = operational[operational.length - 1]
              }
              reorbit_disposal.push(log ? Math.log10(item.pmd.reorbit_disposal) : item.pmd.reorbit_disposal)

            }
            if (item.pmd.targeted_disposal) {
              if (targeted_disposal.some((e) => e !== null && e !== 0) === false) {
                targeted_disposal[targeted_disposal.length - 1] = operational[operational.length - 1]
              }
              targeted_disposal.push(log ? Math.log10(item.pmd.targeted_disposal) : item.pmd.targeted_disposal)

            }

          }
          years.push(item.year)
        })
        apexLineChartWithLablesData.push({
          name: idArray.length > 0 ? `${missionNamesArray[index2]} Launch` : `Launch`,
          data: launch,
        })
        apexLineChartWithLablesData.push(
          {
            name: idArray.length > 0 ? `${missionNamesArray[index2]} Injection` : `Injection`,
            data: injection,
          })
        apexLineChartWithLablesData.push(
          {
            name: idArray.length > 0 ? `${missionNamesArray[index2]} Operational` : `Operational`,
            data: operational,
          })
        apexLineChartWithLablesData.push(
          {
            name: idArray.length > 0 ? `${missionNamesArray[index2]} No disposal` : `No disposal`,
            data: no_disposal,
          })
        apexLineChartWithLablesData.push(
          {
            name: idArray.length > 0 ? `${missionNamesArray[index2]} Direct disposal` : `Direct disposal`,
            data: direct_disposal,
          })
        apexLineChartWithLablesData.push(
          {
            name: idArray.length > 0 ? `${missionNamesArray[index2]} Targeted disposal` : `Targeted disposal`,
            data: targeted_disposal,
          })
        apexLineChartWithLablesData.push(
          {
            name: idArray.length > 0 ? `${missionNamesArray[index2]} Target-orbit deorbit` : `Target-orbit deorbit`,
            data: reorbit_disposal
          })

      })
      const lineChartData = apexLineChartWithLablesData.filter((item) => item.data.some((e) => e !== null && e !== 0) === true)
      const pointArray = []
      for (let i = 0; i < pointPMD.length / 2; i++) {
        pointArray.push({
          x: pointPMD[i],
          y: logartihmic && !isNaN(Math.log10(pointPMD[i + 1])) ? Math.log10(pointPMD[i + 1]) : pointPMD[i + 1],
          marker: {
            size: 4,
            fillColor: ESA_COLORS[2],
            strokeColor: ESA_COLORS[2],
            radius: 2,
          },
        })
      }
      setPointPMD(pointArray)
      setDataLineChart(lineChartData)
      setYears(years)
    }

  }
  const formateOptions = (options) => {

    if (options.length > 0) {
      const optionsSelect = options.map((option) => ({
        value: option?.id || option?.value,
        label: option?.name || option?.label
      }))
      return optionsSelect
    }
  }

  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const Control = ({ children, ...props }) => {

    return (
      <components.Control onChange={(e) => console.log(e)} {...props}>
        {children}
      </components.Control>
    );
  };

  const MenuList = (props) => {
    return (
      <components.MenuList {...props}>
        {/* menu header */}

        {props.children}
      </components.MenuList>
    );
  };
  const getDataFromMissions = () => {
    if (optionsSelected.length > 0) {
      const ids = optionsSelected.map((option) => option.value)
      const names = optionsSelected.map((option) => option.label)
      names.unshift(missionName)
      //ids.unshift(id)
      setMissionNamesArray(names)
      setIdArray(ids)
      setdropdownOpenMission(false)
    }
  }

  const IndicatorsContainer = (props) => {
    const { inputValue, onInputChange } = props.selectProps;
    const debouncedInputValue = useDebounce(inputValue, 1000);
    useEffect(() => {
      if (debouncedInputValue !== '') {
        getPetition(`/api/missions?draft=${draft}&exclude_const=true&name=` + debouncedInputValue)
          .then((data) => {
            if (data.missions) {
              onInputChange('', { action: 'set-value' })
              setMissionOptions(data.missions)
            }
          })
      }
    }, [debouncedInputValue, draft]);
    return (
      <div style={{}}>
        <components.IndicatorsContainer {...props} className="input-group">

        </components.IndicatorsContainer>
      </div>
    );
  };

  const changeLogartihmic = () => {
    setLogartihmic(!logartihmic)
  }
  const checkOption = (e) => {
    if (e.length > 2 && optionsSelected.length < e.length) {
      toast.warning('You can only select 2 missions')
    } else {
      setOptionsSelected(e)
    }
  }

  return (
    <Card className="widget-flat h-100">
      <CardBody>
        <Row>
          <div>
            <h4 style={{ color: '#003247' }} className="header-title float-left col ">DEBRIS INDEX PROFILE</h4>
            <div style={{ display: 'flex', width: '100%', alignContent: 'center', justifyContent: 'left', marginTop: 10 }}>
              <span style={{ color: '#003247', display: 'flex', marginLeft: 13, marginRight: 10 }} >Log scale</span>
              <Switch
                checked={logartihmic}
                onChange={() => changeLogartihmic()}
                onColor="#009bdb"
                onHandleColor="#003247"
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                height={15}
                width={30}
                handleDiameter={20}
                className="react-switch"
                id="material-switch"
              />
            </div>
          </div>
          <Col>
            {(!constellation || spacecraftId !== null) &&
              <Dropdown isOpen={dropdownOpenMission} toggle={toggle2}>
                <DropdownToggle style={{ background: '#003247' }} className="float-right">+</DropdownToggle>
                <DropdownMenu style={{ width: '100%', height: 'auto' }}>
                  <Card>
                    <CardBody>
                      <Row style={{ marginBottom: '10px' }}>
                        <Col xs={8}>
                          <h5 style={{ color: '#003247' }} className="header-title float-left col " >Select Missions</h5>
                        </Col>
                        <Col xs={4}>
                          <div style={{ display: 'flex', width: '100%', alignContent: 'center', justifyContent: 'right', }}>
                            <span style={{ color: '#003247', display: 'flex', marginLeft: 13, marginRight: 10 }} >Planned</span>
                            <Switch
                              checked={draft}
                              onChange={() => setDraft(!draft)}
                              onColor="#009bdb"
                              onHandleColor="#003247"
                              uncheckedIcon={false}
                              checkedIcon={false}
                              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                              height={15}
                              width={30}
                              handleDiameter={20}
                              className="react-switch"
                              id="material-switch"
                            />
                          </div>
                        </Col>
                      </Row>
                      <div className="mb-2 position-relative">
                        <Select
                          placeholder={'Search...'}
                          options={formateOptions(missionOptions)}
                          isMulti={true}
                          components={{ Control, MenuList, IndicatorsContainer }}
                          maxMenuHeight="350px"
                          closeMenuOnSelect={false}
                          controlShouldRenderValue={true}
                          handleClick={onClick}
                          blurInputOnSelect={false}
                          isSearchable
                          isClearable={false}
                          className="dropdown"
                          value={optionsSelected}
                          limit={3}
                          classNamePrefix="react-select"
                          onChange={(e) => {
                            checkOption(e)
                          }}
                        />
                        <Row>
                          {
                            optionsSelected.length > 0 && (
                              <Col>
                                <Button
                                  onClick={() => {
                                    setOptionsSelected([])
                                    setIdArray([])
                                    setMissionNamesArray([])
                                    setPointPMD([])
                                    setdropdownOpenMission(false)
                                  }}
                                  className="btn btn-primary btn-block"
                                  style={{ background: '#003247', border: 'none', marginTop: '10px' }}
                                >
                                  Clear
                                </Button>
                              </Col>
                            )
                          }
                          <Col>
                            <Button
                              onClick={() => { getDataFromMissions() }}
                              className="btn btn-primary btn-block"
                              style={{ background: '#003247', border: 'none', marginTop: '10px' }}
                            >
                              Submit
                            </Button>
                          </Col>
                        </Row>
                      </div>
                    </CardBody>
                  </Card>

                </DropdownMenu>
              </Dropdown>
            }
          </Col>
        </Row>
        {
          error ? (
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignContent: 'center', marginTop: '20px', height: 'auto' }}>
              <Alert color="warning">
                <h4 className="alert-heading">No data available</h4>
                <p>
                  There is no data available for this mission.
                </p>
              </Alert>
            </div>
          ) : (
            loading ? (
              <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
                <Spinner animation="border" />
              </div>
            ) :

              <div className=" chartjs-chart">
                <Chart
                  options={apexLineChartWithLables}
                  series={dataLineChart}
                  type="line"
                  className="apex-charts"
                />
              </div>
          )
        }

      </CardBody>
    </Card>
  )
}

